export const OPEN_CONTACT_MODAL = 'open-contact-modal'
export const REVIEW_AVG = 5
export const TOTAL_REVIEW_COUNT = 59
